import { useThirdPartyRatings } from '../../hooks/useThirdPartyRatings'

// ── ThirdPartyRatings ─────────────────────────────────────────────────────────
// Read-only IMDb / Rotten Tomatoes / Metacritic strip, sibling to StatusStrip.
// Not tappable/interactive like TapToRate — these are external numbers, not
// something the user sets — so a plain row of chips is the right weight, not a
// zoom-stage control (2026-08-21, closing the one verified gap from the
// competitor audit: Movie Paradise/LazyWatch/TVtrack.io all show this trio).
export function ThirdPartyRatings({ showId }) {
  const { imdb, rt, metacritic, hasAny } = useThirdPartyRatings(showId)
  if (!hasAny) return null

  const chips = [
    imdb       && { label: 'IMDb',       value: imdb,       color: 'var(--amber)' },
    rt         && { label: 'RT',         value: rt,         color: 'var(--state-good)' },
    metacritic && { label: 'Metacritic', value: metacritic, color: 'var(--blue-soft)' },
  ].filter(Boolean)

  return (
    <div style={{
      background: 'var(--bg-card)', border: '1px solid var(--border)',
      borderRadius: 'var(--radius-md)', padding: '10px 14px',
      display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
    }}>
      {chips.map(c => (
        <div key={c.label} style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
          <span style={{ color: c.color, fontWeight: 700, fontSize: 11, letterSpacing: '0.02em' }}>{c.label}</span>
          <span style={{ color: 'var(--text)', fontWeight: 600, fontSize: 12.5 }}>{c.value}</span>
        </div>
      ))}
    </div>
  )
}
